import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { createBehaviourEvent } from './thunks';
import { BehaviourEventState } from './types';

const initialState: BehaviourEventState = {
  createBehaviourEvent: {
    data: null,
    status: 'idle',
  },
};

export const createBehaviourEventAsync = createAsyncThunk(
  'createBehaviourEvent',
  createBehaviourEvent
);

export const slice = createSlice({
  name: 'behaviourEvent',
  initialState,
  reducers: {
    clear: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createBehaviourEventAsync.pending, (state) => {
        state.createBehaviourEvent.status = 'loading';
      })
      .addCase(createBehaviourEventAsync.fulfilled, (state, action) => {
        state.createBehaviourEvent = {
          data: action.payload,
          status: 'loading',
        };
      })
      .addCase(createBehaviourEventAsync.rejected, (state) => {
        state.createBehaviourEvent.status = 'failed';
      });
  },
});

export const actions = slice.actions;

export default slice.reducer;
